export async function AutoThrow(
  error: Error | Promise<Error | undefined> | undefined
) {
  const e = await Promise.resolve(error)

  if (e) {
    throw e
  }
}
